<template>
<sui-page>
  <sui-page-header :title="pageTitle" :location-list="pageLocations" :is-favorites="isMyFavorites"></sui-page-header>
  <sui-page-contents>
    <div class="mr15">
      <div class="comm_title_wrap">
        <h4>트리 기본</h4>
      </div>
      <sui-tree v-bind="fdpTree00" mutiple  class="brdG01 pd20" style="height:250px; overflow-y:auto" @item-double-click="onItemDoubleClick"></sui-tree>
      <div class="comm_title_wrap">
        <h4>트리 체크박스</h4>
      </div>
      <div class="comm_title_wrap">
        <h4>editable = false </h4>
      </div>
      <sui-tree v-bind="fdpTree00" :editable="'false'" :show-checkbox="showCheckbox" class="brdG01 pd20" style="height:250px; overflow-y:auto"></sui-tree>
      <div class="comm_title_wrap">
        <h4>트리 멀티선택</h4>
      </div>
      <sui-tree v-bind="fdpTree00" :show-checkbox="showCheckbox" :multiple="isMultiSelect" class="brdG01 pd20" style="height:250px; overflow-y:auto"></sui-tree>
      <div class="comm_title_wrap">
        <h4>트리 select/deselect</h4>
      </div>
      <sui-tree ref="tree04" v-bind="fdpTree00" :show-checkbox="showCheckbox" :multiple="isMultiSelect" class="brdG01 pd20" style="height:250px; overflow-y:auto"></sui-tree>      
      <sui-tree ref="tree05" v-bind="fdpTree00" :show-checkbox="showCheckbox" class="brdG01 pd20" style="height:250px; overflow-y:auto"></sui-tree>
      <div>
        <button class="mybtn" @click="onClickSelect">select</button>
        <button class="mybtn" @click="onClickDeselect">deselect</button>
        <button class="mybtn" @click="onClickPrint">print selection</button>
        <button class="mybtn" @click="onClickExpand">expand</button>
        <button class="mybtn" @click="onClickCollapse">collapse</button>
        <button class="mybtn" @click="onClickReveal">reveal</button>
      </div>
    </div>
  </sui-page-contents>
</sui-page>
</template>

<script>
  export default {
    name: "TMP_COM_002",
    data() {
      return {
        isMultiSelect: true,
        showCheckbox: true,
        pageTitle: "Grid UI",
        pageLocations: ["디자인가이드", "컴포넌트 가이드", "Grid UI"],
        isPageHeaderShow: true,
        selected: {
          md: {
            key: '',
            label: ''
          },
          smd: {
            key: '',
            label: ''
          },
          code: {
            key: '',
            label: ''
          },
          lang: {
            key: '',
            label: ''
          },
          yn: {
            key: '',
            label: ''
          },
          custom: {
            key: '개발',
            label: ''
          },
          customlang: {
            key: '',
            label: ''
          },
        },
        customOptions: [{
            key: 'D',
            label: '개발'
          },
          {
            key: 'F',
            label: '완료'
          },
        ],
        localdata0: [
          ['', '111231231', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '111231231', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '111231231', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '111231231', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '111231231', '1321321313', '1321321313', '12313', '2019-01-20'],
          ['', '111231231', '1321321313', '1321321313', '12313', '2019-01-20']
        ],
        gridColumns0: [{
          text: '',
          columntype: 'checkbox',
          datafield: 'chk',
          align: 'center',
          width: '40',
          renderer: function(elem) {
            return '<div id="checkbox" style="z-index: 999; margin-top: 8px; margin-left:8px" @click="selectAll"></div>';
          },
          rendered: function(element, align, height) {
            element.jqxCheckBox();
          }
        }, {
          text: '기본 텍스트',
          datafield: 'datafield1'
        }, {
          text: '텍스트필드',
          datafield: 'textfield',
          createwidget: (row, column, value, htmlElement) => {
            const componentInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
              trim: true,
            }, this.dataset0);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '셀렉트박스',
          datafield: 'datafield2',
          createwidget: (row, column, value, htmlElement) => {
            const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.customOptions,
            }, this.dataset0);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '라디오버튼',
          datafield: 'datafield3',
          $component: this,
          createwidget: (row, column, value, htmlElement) => {
            const componentInstance = utils.getGridCellFactory().createCellRadioGroup(row, column, value, htmlElement, {
              items: [{
                key: 'Y',
                label: 'Yes'
              }, {
                key: 'N',
                label: 'No'
              }],
            }, this.dataset0);
          },
          initwidget(row, column, value, htmlElement) {
            utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          },
        }, {
          text: '데이트피커',
          datafield: 'datafield4'
        }],
        fdpTree00: {
          data: [{
            text: 'G-EHS',
            opened: true,
            children: [{
              text: 'Tree01 depth_1',
              id: 'btn01',
              opened: true,
              children: [{
                text: 'Tree01 depth_2',
                opened:true,
                children:[
                  {text:'Tree01 depth_30',
                  id: 'item30',
                   opened: true,
                   children: [{text:'Tree01 depth_40', selectable: true},{text:'Tree01 depth_41', selectable: false}]
                },
                  {text:'Tree01 depth_31'},{text:'Tree01 depth_32'},{text:'Tree01 depth_33'},{text:'Tree01 depth_34'}]

              }, {
                text: 'Tree01 depth_2'
              }]
            }, {
              text: 'Tree02 depth_1'
            },
            {
              text: 'Tree03 depth_1'
            },
            {
              text: 'Tree04 depth_1',
              opened:true,
              children: [{text:'Tree04 depth_21'},{text:'Tree04 depth_22'},{text:'Tree04 depth_23'}]

            },
            {
              text: 'Tree05 depth_1'
            }]
          }]
        },
        localdata1: [
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4']
        ],
        gridColumns1: [{
          text: '컬럼01',
          datafield: 'datafield0'
        }, {
          text: '타이틀이겁나길면어떻게들어가나봅시다',
          datafield: 'datafield1'
        }, {
          text: '이만큼쓰면넘어가려나점이생기려나',
          datafield: 'datafield2'
        }, {
          text: '일하기싫을때는 집에가자 먹고싶을땐 대지같이 먹자',
          datafield: 'datafield3'
        }],
        localdata2: [
          ['1', '로또1등 2번이나 당첨된 사람', '취미로 회사다니는 사람', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['취미로 회사다니는 사람', '22', '33', '가진게돈밖에 없는 사람', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55']
        ],
        gridColumns2: [{
          text: '제목',
          datafield: 'datafield0'
        }, {
          text: '이름이길어지면 이게 맞는건가',
          datafield: 'datafield1'
        }, {
          text: '공백',
          datafield: 'datafield2'
        }, {
          text: '나도몰라',
          datafield: 'datafield3'
        }, {
          text: '오늘할일은내일로',
          datafield: 'datafield4'
        }]
      };
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
        name: 'chk',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'textfield',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '4'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '5'
      }]
    }, {
      id: 'dataset1',
      type: 'local',
      data: 'localdata1',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }]
    }, {
      id: 'dataset2',
      type: 'local',
      data: 'localdata2',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '4'
      }]
    }],
    methods: {
      onClickSelect() {
        this.$refs.tree04.select('btn01');
        this.$refs.tree05.select('btn01');
        //this.$refs.tree04.select(1);
        //this.$refs.tree04.select(2);
        //this.$refs.tree04.select(5);
      },
      onClickDeselect() {
        this.$refs.tree04.deselect(2);
        this.$refs.tree05.deselect(5);
      },
      onClickPrint() {
        this.$refs.tree04.getNodeById('btn01').opened = false;
        console.log(this.$refs.tree04.getSelection());
        this.$refs.tree05.getNodeById('btn01').opened = false;
        console.log(this.$refs.tree05.getSelection());
      },
      onItemDoubleClick(node, model) {
        console.log(model.id);
      },
      onClickExpand() {
        this.$refs.tree04.getNodeById('btn01').opened = true;
        this.$refs.tree05.getNodeById('btn01').opened = true;
      },
      onClickCollapse() {
        this.$refs.tree04.getNodeById('btn01').opened = false;
        this.$refs.tree05.getNodeById('btn01').opened = false;
      },
      onClickReveal() {
        this.$refs.tree04.revealNode('item30');
        this.$refs.tree05.revealNode('item30');
      }
    }
  };
</script>
<style scoped>
.mybtn {
  width:100px;
  height: 30px;
  border: 1px solid blue;
}
</style>
